import React from "react";
import { useDispatch } from "react-redux";
import JobList from "../components/jobs/JobList";
import Sidebar from "../components/sidebar/Sidebar";

const Home = () => {
  return (  
      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 md:px-8 ">
        <Sidebar />
        <JobList />
      </div>
  );
};

export default Home;
